export function isScrolledToBottom(event: Event) {
    const element = event.target as HTMLUListElement;
    return element.offsetHeight + Math.ceil(element.scrollTop) >= element.scrollHeight;
}

export function isVerticallyScrollable(targetElement: HTMLDivElement, elementClass: string) {
    const parentElement = targetElement.parentElement;
    const element = parentElement.querySelector(elementClass);
    return element.scrollHeight > element.clientHeight;
}
